module.exports = __webpack_public_path__ + "img/customer.32239227.svg";